import { TradingSpinner } from '@trading-ui/core';
import { BinIcon, PencilIcon } from '@trading-ui/icons';

import i18n from '@/i18n/config';

import type { PricingIndex } from '@/api/services/settings/pricing-indices.service';

const formatDateTime = (isoDate: string): string => {
  const date = new Date(isoDate);
  return date.toLocaleString('es-ES', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
};

type Params = {
  setSelectedPricingIndex: (pricingIndex: PricingIndex) => void;
  handleDeletePricingIndex: (id: number) => void;
  deletingId: number | null;
};

export const getPricingIndicesColumns = ({ setSelectedPricingIndex, handleDeletePricingIndex, deletingId }: Params) => [
  {
    Header: i18n.t('settings.pricingIndicesTab.table.columns.name'),
    accessor: 'name',
    width: 60,
    cellStyle: () => ({ backgroundColor: 'rgba(4, 120, 178, 0.2)', color: '#0478B2' }),
  },
  {
    Header: i18n.t('settings.pricingIndicesTab.table.columns.timeLimitLower'),
    accessor: 'timeLimitLower',
    width: 40,
  },
  {
    Header: i18n.t('settings.pricingIndicesTab.table.columns.timeLimitUpper'),
    accessor: 'timeLimitUpper',
    width: 40,
  },
  {
    Header: i18n.t('settings.pricingIndicesTab.table.columns.createdAt'),
    accessor: 'createdAt',
    width: 60,
    Cell: ({ value }: { value: string }) => formatDateTime(value),
  },
  {
    Header: i18n.t('settings.pricingIndicesTab.table.columns.updatedAt'),
    accessor: 'updatedAt',
    width: 60,
    Cell: ({ value }: { value: string }) => formatDateTime(value),
  },
  {
    Header: '',
    accessor: 'edit',
    width: 20,
    cellStyle: () => ({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      cursor: 'pointer',
      backgroundColor: 'rgba(4, 120, 178, 0.2)',
      color: '#0478B2',
    }),
    Cell: ({ row }: { row: { original: PricingIndex } }) => (
      <PencilIcon size={24} className="icon-hover" onClick={() => setSelectedPricingIndex(row.original)} />
    ),
  },
  {
    Header: '',
    accessor: 'delete',
    width: 20,
    cellStyle: () => ({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      cursor: 'pointer',
      backgroundColor: 'rgba(4, 120, 178, 0.2)',
      color: '#0478B2',
    }),
    Cell: ({ row }: { row: { original: PricingIndex } }) =>
      deletingId === row.original.id ? (
        <TradingSpinner size={24} color="secondary" />
      ) : (
        <BinIcon size={24} className="icon-hover" onClick={() => handleDeletePricingIndex(row.original.id)} />
      ),
  },
];
